// extracted by mini-css-extract-plugin
module.exports = {"animatedArrow":"index-module--animatedArrow--3nYnh"};